import { dataTableParamsBuilder } from "../../utils/data-table-params-builder";
import { usePaginationQuery } from "../../utils/hooks";
import { http } from "../../utils/http";

function fetchHospitalOrders(params, hospitalId) {
  const baseUrl = window.location.origin;
  const endpointUrl = new URL("/admin/product-order-histories", baseUrl);

  if (hospitalId) {
    endpointUrl.searchParams.append("hospitalId", hospitalId);
  }

  if (params.productName) {
    endpointUrl.searchParams.append("productName", params.productName);
  }

  if (params.orderNo) {
    endpointUrl.searchParams.append("orderNo", params.orderNo);
  }

  if (params.type) {
    endpointUrl.searchParams.append("type", params.type);
  }

  if (params.status) {
    endpointUrl.searchParams.append("status", params.status);
  }

  dataTableParamsBuilder({
    searchParams: endpointUrl.searchParams,
    filterValues: [params.order],
    ...params,
  });

  return http(endpointUrl.toString().replace(baseUrl, ""));
}

export function useHospitalOrderList(params = {}, hospitalId) {
  return usePaginationQuery(
    [
      "hospital-orders",
      hospitalId,
      params.productName,
      params.orderNo,
      params.type,
      params.status,
    ],
    (paginationState) =>
      fetchHospitalOrders({ ...params, ...paginationState }, hospitalId)
  );
}
